import { render, staticRenderFns } from "./CbsColorPicker.vue?vue&type=template&id=dcb3565e&scoped=true&"
import script from "./CbsColorPicker.vue?vue&type=script&lang=js&"
export * from "./CbsColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./CbsColorPicker.vue?vue&type=style&index=0&id=dcb3565e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb3565e",
  null
  
)

export default component.exports